export const GLOBAL_URL = {
  HEALTHLOCKER_URL : process.env.REACT_APP_HEALTH_LOCKER_URL,
  IHX_PRO: process.env.REACT_APP_API_BASE_URL,
  CRM_BASE_URL: process.env.REACT_APP_CRM_BASE_URL,
  CRM_OUTPATIENT_URL: process.env.REACT_APP_CRM_OUTPATIENT_URL,
  REACT_APP_INVENTORY_API_BASE_URL: process.env.REACT_APP_INVENTORY_API_BASE_URL,
  REACT_APP_COMMON_BUCKET_URL: process.env.REACT_APP_COMMON_BUCKET_URL,
};
